import { FC } from "react";
import { Info } from "lucide-react";
import { MEDIUM_ICON_SIZE_STYLES } from "../../ui/styles";

export const ErrorWrapper: FC<
  React.PropsWithChildren<{ errorMessage?: string }>
> = ({ errorMessage, children }) => {
  return (
    <>
      <>{children}</>

      {errorMessage && (
        <div className="mt-4 flex text-red-600">
          <Info className={`mr-2 ${MEDIUM_ICON_SIZE_STYLES}`} />
          {errorMessage}
        </div>
      )}
    </>
  );
};
